<template>
    <el-container class="healthy page-x" direction="vertical">
        <drag-dialog title="专家预约服务详情" v-model="dialogVisible">
            <div class="dialog-list">
                <div class="title">就诊人信息</div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">姓名：</div>
                    <div class="dialog-list-text">{{ dialogData.name }}</div>
                    <div class="dialog-list-title">性别：</div>
                    <div class="dialog-list-text">{{ dialogData.gender=='1' ? '男' : '女' }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">年龄：</div>
                    <div class="dialog-list-text">{{ dialogData.age }}</div>
                    <div class="dialog-list-title">手机号：</div>
                    <div class="dialog-list-text">{{ dialogData.mobile }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">证件类型：</div>
                    <div class="dialog-list-text">{{ cardType[dialogData.cardType] || dialogData.cardType }}</div>
                    <div class="dialog-list-title">证件号：</div>
                    <div class="dialog-list-text">{{ dialogData.cardNo }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">有无医保：</div>
                    <div class="dialog-list-text">{{ dialogData.medicalInsuranceFlag == '1' ? '有' : '无' }}</div>
                </div>
                <div class="title">服务信息</div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">就医经理：</div>
                    <div class="dialog-list-text">{{ dialogData.medicalManagerName }}</div>
                    <div class="dialog-list-title">就医经理电话：</div>
                    <div class="dialog-list-text">{{ dialogData.medicalManagerMobile }}</div>
                </div>
                <div class="title">就诊信息</div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">期望医院：</div>
                    <div class="dialog-list-text">{{ dialogData.expectationHospital }}</div>
                    <div class="dialog-list-title">期望科室：</div>
                    <div class="dialog-list-text">{{ dialogData.expectationDepartment }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">就诊时间：</div>
                    <div class="dialog-list-text">{{ dialogData.treatmentTime }}</div>
                    <div class="dialog-list-title">就诊城市：</div>
                    <div class="dialog-list-text">{{ dialogData.treatmentCity }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">医院：</div>
                    <div class="dialog-list-text">{{ dialogData.hospitalName }}</div>
                    <div class="dialog-list-title">医院地址：</div>
                    <div class="dialog-list-text">{{ dialogData.hospitalAddress }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">科室：</div>
                    <div class="dialog-list-text">{{ dialogData.department }}</div>
                    <div class="dialog-list-title">医生：</div>
                    <div class="dialog-list-text">{{ dialogData.doctor }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">陪诊人：</div>
                    <div class="dialog-list-text">{{ dialogData.accompanyName }}</div>
                    <div class="dialog-list-title">陪诊人电话：</div>
                    <div class="dialog-list-text">{{ dialogData.accompanyMobile }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">主诉：</div>
                    <div class="dialog-list-text">{{ dialogData.demand }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">病例资料：</div>
                    <div class="dialog-list-text" v-if="dialogData.medicalRecord">
                        <el-image :src="item" alt="" v-for="(item,i) in dialogData.medicalRecordSplit" :key="i" />
                    </div>
                </div>
                <div class="title">服务评价</div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">用户评价：</div>
                    <div class="dialog-list-text">{{ dialogData.userEvaluation }}</div>
                </div>
                <div class="title">服务轨迹</div>
                <div class="dialog-list-box">
                    <el-table :data="historicalTrack" border style="width: 100%">
                        <el-table-column prop="changeTime" label="时间"></el-table-column>
                        <el-table-column prop="targetStatus" label="状态"></el-table-column>
                        <el-table-column prop="remark" label="备注"></el-table-column>
                    </el-table>
                </div>
            </div>
        </drag-dialog>
    </el-container>
</template>

<script>
import dragDialog from "@/components/health/dragDialog.vue";
import { cardType, orderState, relation } from "@/assets/js/options";
import { dateFormat } from "@/assets/js/until.js";
export default {
    name: "expertAppointmentDialog",
    components: { dragDialog },
    data() {
        return {
            cardType, // 证件类型list
            orderState, // 订单状态list
            relation, // 与权益人关系list
            // 弹窗
            dialogVisible: false, // 弹窗visible
            dialogData: {}, // 弹窗中的数据
            historicalTrack: [], // 订单状态历史轨迹
        };
    },
    methods: {
        /**
         * 显示弹窗
         */
        showDetail(id) {
            // 清空状态
            this.dialogData = {}
            this.historicalTrack = []
            this.dialogVisible = true;
            // 请求
            this.getDetail(id)
            this.getHistoricalTrack(id)
        },
        /**
         * 获取订单详情
         */
        async getDetail(id) {
            let res = await this.axios.get(this.getApiUrl("appointmentOrderInfo"), {
                params: { id },
            });
            if (res?.data) {
                if (res.data?.medicalRecord) res.data.medicalRecordSplit = res.data.medicalRecord.split(',') || []
                this.dialogData = res?.data || {};
                console.log(this.dialogData)
            }
        },
        /**
         * 订单状态历史轨迹
         */
        async getHistoricalTrack(id) {
            let res = await this.axios.get(this.getApiUrl("appointmentOrderHistoricalTrack"), {
                params: { orderId: id },
            });
            this.historicalTrack = res?.data || [];
            console.log(this.historicalTrack)
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/color.scss";

.dialog-list {
    .title {
        height: 30px;
        line-height: 30px;
        margin-bottom: 20px;
        font-weight: bold;
        padding-left: 20px;
        margin-top: 18px;
        position: relative;

        &::before {
            content: "";
            display: block;
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 8px;
            background-color: $theme;
        }
    }

    .dialog-list-box {
        padding-bottom: 10px;
        display: flex;

        .dialog-list-title {
            padding-left: 20px;
            width: 100px;
            white-space: nowrap;
            text-align: right;
        }

        .dialog-list-text {
            flex: 1;
        }
    }
}
</style>